<template>
  <div class="md-offset">
    <div class="wrapp">
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-primary">
          <div class="card-icon">
            <md-icon>extension</md-icon>
          </div>
        </md-card-header>
        <md-card-content>
          <div class="config-block" v-if="isTreatmentAbroadAvailable">
            <div class="config-block__header">
              <md-switch
                class="config-block__switch success"
                v-model="isTreatmentAbroadActive"
              />
              <h4 class="title">
                Finansowanie leczenia za granicą
              </h4>
              <a
                @click.prevent="showInfoModal(modals.treatmentAbroad.modal)"
                href="/"
                class="info-icon"
              >
                <md-icon class="text-info">info_outline</md-icon>
                <md-tooltip md-direction="bottom">
                  {{ modals.treatmentAbroad.tooltip }}
                </md-tooltip>
              </a>
            </div>
            <div v-if="isTreatmentAbroadActive" class="md-layout">
              <div
                class="md-layout md-layout-item md-xsmall-size-100 md-medium-size-50 md-large-size-50 md-xlarge-size-40"
              >
                <div class="labeled-toggler md-layout-item md-size-100">
                  <p class="labeled-toggler__label">
                    Ochrona indywidualna
                  </p>
                  <md-switch
                    class="config-block__switch success"
                    v-model="treatmentAbroad.personal"
                    @change="
                      treatmentAbroad.family.active = !treatmentAbroad.personal
                    "
                  />
                </div>
                <div
                  class="labeled-toggler labeled-toggler_family md-layout-item md-size-100"
                >
                  <p class="labeled-toggler__label">
                    Ochrona dla rodziny
                  </p>
                  <md-switch
                    class="config-block__switch success"
                    v-model="treatmentAbroad.family.active"
                    @change="
                      treatmentAbroad.personal = !treatmentAbroad.family.active
                    "
                  />
                </div>
              </div>
              <slide-y-down-transition>
                <div
                  class="md-layout-item md-xsmall-size-100 md-medium-size-40"
                  v-if="treatmentAbroad.family.active"
                >
                  <md-field class="select select_family">
                    <label>Dorosli: 18 - 64 lat</label>
                    <md-select v-model="treatmentAbroad.family.adults">
                      <md-option value="1">1</md-option>
                      <md-option value="2">2</md-option>
                    </md-select>
                  </md-field>
                  <md-field class="select">
                    <label>Dzieci: 0 - 17 lat</label>
                    <md-select v-model="treatmentAbroad.family.children">
                      <md-option value="0">0</md-option>
                      <md-option value="1">1</md-option>
                      <md-option value="2">2</md-option>
                      <md-option value="3">3</md-option>
                      <md-option value="4">4</md-option>
                      <md-option value="5">5</md-option>
                      <md-option value="6">6</md-option>
                      <md-option value="7">7</md-option>
                    </md-select>
                  </md-field>
                </div>
              </slide-y-down-transition>
            </div>
          </div>
          <div class="config-block" v-if="isIllnessInsuranceAvailable">
            <div class="config-block__header">
              <md-switch
                class="config-block__switch success"
                v-model="isMoneySupportActive"
              />
              <h4 class="title">Wsparcie finansowe w chorobie</h4>
              <a
                @click.prevent="showInfoModal(modals.moneySupport)"
                href="/"
                class="info-icon"
              >
                <md-icon class="text-info">info_outline</md-icon>
                <md-tooltip md-direction="bottom">{{
                  modals.moneySupport.tooltip
                }}</md-tooltip>
              </a>
            </div>
            <div v-if="isMoneySupportActive" class="config-block__content">
              <div class="slider-block">
                <div class="slider-block__label">
                  <p class="slider-block__name">
                    Budżet na nierefundowane świadczenie medyczne i usługi
                  </p>
                  <a
                    @click.prevent="showInfoModal(modals.budget)"
                    href="/"
                    class="info-icon"
                  >
                    <md-icon class="text-info">info_outline</md-icon>
                    <md-tooltip md-direction="bottom">{{
                      modals.budget.tooltip
                    }}</md-tooltip>
                  </a>
                </div>
                <Slider
                  :step="5000"
                  :range="{ min: 0, max: 800000 }"
                  v-model="moneySupport.budget"
                />
                <div class="slider-block__display-value">
                  {{ moneySupport.budget | currency }}
                </div>
                <div class="slider-block__display-value">
                  {{ budgetPercentage }}
                </div>
              </div>
              <div class="slider-block">
                <div class="slider-block__label">
                  <p class="slider-block__name">
                    Miesięczne wsparcie w okresie leczenia [6 miesięcy]
                  </p>
                  <a
                    @click.prevent="showInfoModal(modals.monthlySupport)"
                    href="/"
                    class="info-icon"
                  >
                    <md-icon class="text-info">info_outline</md-icon>
                    <md-tooltip md-direction="bottom">{{
                      modals.monthlySupport.tooltip
                    }}</md-tooltip>
                  </a>
                </div>
                <Slider
                  :step="100"
                  :range="{ min: 0, max: 20000 }"
                  v-model="moneySupport.monthlySupport"
                />
                <div class="slider-block__display-value">
                  {{ moneySupport.monthlySupport | currency }}
                </div>
              </div>
              <div class="slider-block__sum">
                <p class="slider-block__info">
                  Rekomendowana suma
                  <span>ubezpieczenia:</span>
                </p>
                <span class="slider-block__value">
                  {{ moneySupportSum | currency }}
                </span>
              </div>
            </div>
          </div>
          <div class="config-block">
            <div class="config-block__header">
              <md-switch
                class="config-block__switch success"
                v-model="isLifeInsuranceActive"
              />
              <h4 class="title">Ubezpieczenie na życie</h4>
              <a
                @click.prevent="showInfoModal(modals.lifeInsurrance)"
                href="/"
                class="info-icon"
              >
                <md-icon class="text-info">info_outline</md-icon>
                <md-tooltip md-direction="bottom">{{
                  modals.lifeInsurrance.tooltip
                }}</md-tooltip>
              </a>
            </div>
            <div v-if="isLifeInsuranceActive" class="config-block__content">
              <div class="slider-block">
                <div class="slider-block__label">
                  <p class="slider-block__name">
                    Zadłużenie i inne zobowiązania
                  </p>
                  <a
                    @click.prevent="showInfoModal(modals.debt)"
                    href="/"
                    class="info-icon"
                  >
                    <md-icon class="text-info">info_outline</md-icon>
                    <md-tooltip md-direction="bottom">{{
                      modals.debt.tooltip
                    }}</md-tooltip>
                  </a>
                </div>
                <Slider
                  :step="5000"
                  :range="{ min: 0, max: 2000000 }"
                  v-model="lifeInsurance.debt"
                />
                <div class="slider-block__display-value">
                  {{ lifeInsurance.debt | currency }}
                </div>
              </div>
              <div class="slider-block">
                <div class="slider-block__label">
                  <p class="slider-block__name">
                    Miesięczne wsparcie dla rodziny
                  </p>
                  <a
                    @click.prevent="showInfoModal(modals.monthlyFamiliSupport)"
                    href="/"
                    class="info-icon"
                  >
                    <md-icon class="text-info">info_outline</md-icon>
                    <md-tooltip md-direction="bottom">{{
                      modals.monthlyFamiliSupport.tooltip
                    }}</md-tooltip>
                  </a>
                </div>
                <Slider
                  :step="100"
                  :range="{ min: 0, max: 20000 }"
                  v-model="lifeInsurance.familySupport"
                />
                <div class="slider-block__display-value">
                  {{ lifeInsurance.familySupport | currency }}
                </div>
              </div>
              <div class="slider-block">
                <div class="slider-block__label">
                  <p class="slider-block__name">
                    Okres zabezpieczenia rodziny
                  </p>
                  <a
                    @click.prevent="showInfoModal(modals.period)"
                    href="/"
                    class="info-icon"
                  >
                    <md-icon class="text-info">info_outline</md-icon>
                    <md-tooltip md-direction="bottom">{{
                      modals.period.tooltip
                    }}</md-tooltip>
                  </a>
                </div>
                <Slider
                  :step="1"
                  :range="{ min: 1, max: 30 }"
                  v-model="lifeInsurance.period"
                />
                <div class="slider-block__display-value">
                  {{ lifeInsurance.period | year }}
                </div>
              </div>
              <slide-y-down-transition>
                <div
                  class="labeled-toggler labeled-toggler_wide"
                  v-if="lifeInsurance.period >= 5"
                >
                  <p class="labeled-toggler__label">
                    Gwarancja stałej składki w okresie zabezpieczenia
                  </p>
                  <div class="labeled-toggler__actions-block">
                    <md-switch
                      class="config-block__switch success"
                      v-model="lifeInsurance.guarantee"
                    />
                    <a
                      @click.prevent="showInfoModal(modals.guarantee)"
                      href="/"
                      class="info-icon"
                    >
                      <md-icon class="text-info">info_outline</md-icon>
                      <md-tooltip md-direction="bottom">{{
                        modals.guarantee.tooltip
                      }}</md-tooltip>
                    </a>
                  </div>
                </div>
              </slide-y-down-transition>
              <div class="slider-block__sum">
                <p class="slider-block__info">
                  Rekomendowana suma
                  <span>ubezpieczenia:</span>
                </p>
                <span class="slider-block__value">
                  {{ lifeInsuranceSum | currency }}
                </span>
              </div>
            </div>
          </div>
        </md-card-content>
      </md-card>
      <md-card class="chart-card">
        <md-card-content>
          <div class="chart-card-nav">
            <a
              @click.prevent="showCalc()"
              class="chart-card-nav__link md-simple md-sm"
            >
              <md-icon md-src="/icons/calc.svg" />
              <md-tooltip md-direction="bottom"
                >Kalkulator renty rodzinnej</md-tooltip
              >
            </a>
            <a
              @click.prevent="setDefaultValues()"
              class="chart-card-nav__link md-simple md-sm"
            >
              <md-icon>refresh</md-icon>
              <md-tooltip md-direction="bottom">Resetuj</md-tooltip>
            </a>
          </div>
          <div class="chart-wrapp">
            <doughnut-chart :chart-data="chartData" :options="chartOptions" />
            <div class="final-part-info">
              <div class="final-part-info__text">
                <p>
                  Miesięczny koszt
                </p>
                <p>
                  planu ubezpieczeniowego
                </p>
              </div>
              <div class="final-part-info__sum">
                {{ finalMonthlySum | currency(2) }}
              </div>
            </div>
          </div>
          <div class="chart-legend">
            <slide-y-down-transition
              :key="item.name"
              v-for="item in chartLegend"
            >
              <div class="chart-legend__item">
                <div
                  class="chart-legend__indicator"
                  :style="{ background: item.color }"
                />
                <span class="chart-legend__name">
                  {{ item.name }}
                </span>
              </div>
            </slide-y-down-transition>
          </div>

          <md-button
            :disabled="
              !isLifeInsuranceActive &&
                !isTreatmentAbroadActive &&
                !isMoneySupportActive
            "
            @click="nextStep()"
            class="md-info chart-btn"
            >Przejdź do podsumowania
            <md-icon>chevron_right</md-icon>
          </md-button>
        </md-card-content>
      </md-card>
      <div class="bottom-nav">
        <div>
          <a
            @click.prevent="showCalc()"
            class="chart-card-nav__link md-simple md-sm"
          >
            <md-icon md-src="/icons/calc.svg" />
          </a>
          <a
            @click.prevent="setDefaultValues()"
            class="chart-card-nav__link md-simple md-sm"
          >
            <md-icon>refresh</md-icon>
          </a>
        </div>
        <div class="bottom-nav__text">
          <span class="bottom-nav__label">
            Koszt planu(mc):
          </span>
          <span class="bottom-nav__sum">
            {{ finalMonthlySum | currency(2) }}
          </span>
        </div>
        <md-button
          :disabled="
            !isLifeInsuranceActive &&
              !isTreatmentAbroadActive &&
              !isMoneySupportActive
          "
          @click="nextStep()"
          class="md-info bottom-nav__btn md-just-icon md-round"
        >
          <md-icon>chevron_right</md-icon>
        </md-button>
      </div>
    </div>
    <ConfiguratorModal ref="modalInfo" />
    <optionalCalculator ref="optionalCalc" />
  </div>
</template>

<script>
import Axios from 'axios'
import ConfiguratorModal from '../../components/ConfiguratorModal'
import { mapState } from 'vuex'
import optionalCalculator from '../../components/optionalCalculator'

import DoughnutChart from '../../components/DoughnutChart'
import Slider from '../../components/Slider'
export default {
  name: 'Calculator',
  components: {
    Slider,
    DoughnutChart,
    ConfiguratorModal,
    optionalCalculator,
  },
  created() {},
  mounted() {
    this.$store.dispatch('getAllConstants', { age: this.age })
    this.setup()
  },
  data() {
    return {
      chartLegend: [
        {
          color: '#F44336',
          name: 'Finansowanie leczenia za granicą',
        },
        {
          color: '#FF9800',
          name: 'Wsparcie finansowe w chorobie',
        },
        {
          color: '#9C27B0',
          name: 'Ubezpieczenie na życie',
        },
      ],
      chartData: null,
      chartOptions: {
        aspectRatio: 1,
        layout: {
          padding: {
            left: 0,
            right: 0,
            top: 0,
            bottom: 0,
          },
        },
        tooltips: {
          enabled: this.finalMonthlySum > 0,
        },
        responsive: true,
        cutoutPercentage: 90,
        legend: {
          display: false,
        },
        title: {
          display: false,
        },
      },
      //api
      Min_skladka_PO: null, //
      Oplata_admin: null, //
      Min_SU: null,
      Max_SU: null,
      Max_wiek_umowa: null,
      Min_wiek_umowa: null,
      Min_okres_term: null, //
      Okres_ochrony: null, //
      Min_SU_PZ: null,
      Max_SU_PZ: null,
      Skladka_roczna_DOM: null,
      Skladka_mies_DOM: null,
      Min_renta_rodz: null,
      Min_renta_rodz_nie: null,
      Wiek_emeryt: null,
      Stopa_renta_rodz: null,
      Staz_renta_rodz: null,
      Max_renta_rodz_wymiary: null,
      Skladka_17: null, //
      Skladka_64: null, //

      //end api
      age: parseInt(JSON.parse(localStorage.getItem('birthday')).age),
      maxContractTerm: null,
      maxAnnualContractTerm: null,
      isIllnessInsuranceAvailable: null,
      isTreatmentAbroadAvailable: null,
      isLifeInsuranceActive: false,
      isMoneySupportActive: false,
      isTreatmentAbroadActive: false,
      lifeInsurance: {
        period: 10,
        debt: 200000,
        familySupport: 1500,
        guarantee: false,
      },
      moneySupport: {
        monthlySupport: 1500,
        budget: 100000,
      },
      treatmentAbroad: {
        personal: true,
        family: {
          active: false,
          children: 2,
          adults: 2,
        },
      },
      loading: true,
      //tooltips and modals
      modals: {
        treatmentAbroad: {
          tooltip:
            'Zapewnij sobie dostęp do najlepszej opieki medycznej na całym świecie ...',
          modal: {
            title: 'Finansowanie leczenia za granicą',
            text: [
              'To wariant ochrony ubezpieczeniowej polegającej na zapewnieniu dostępu do świadczeń medycznych na każdym etapie leczenia 6 tzw. poważnych stanów chorobowych (w tym nowotworów): ',
              '1. Szybka diagnostyka - dostęp do badań i konsultacji specjalistycznych już na etapie podejrzenia choroby. ',
              '2. Druga opinia medyczna - możliwość weryfikacji diagnozy i leczenia wdrożonego w Polsce - raport z rekomendacjami zagranicznych ekspertów. ',
              '3. Opieka medyczna za granicą - organizacja i finansowanie procesu leczenia w wybranej, renomowanej zagranicznej placówce medycznej wyspecjalizowanej w leczeniu danego schorzenia. ',
              '4. Opieka kontrolna po powrocie do Polski - plan i nadzór zagranicznych lekarzy, refundacja leków i diagnostyki w okresie rekonwalescencji. ',
              'Limit wartości wszystkich świadczeń w ramach umowy to 2 mln Euro. <a href="https://app.zbudujplan.pl/docs/Raport_oświadczenie_Best_Doctors.pdf" target="_blank" rel="noreferrer">Dołączając do programu</a>, można być objętym ochroną nawet do 85 roku życia.',
            ],
          },
        },
        moneySupport: {
          tooltip:
            'Uruchom prywatny budżet ubezpieczeniowy na ewentualność poważnej choroby ...',
          title: 'Wsparcie finansowe w chorobie',
          text: [
            'To stricte finansowa ochrona ubezpieczeniowa - po zdiagnozowaniu dowolnego z listy 29 poważnych zachorowań Ubezpieczyciel wypłaca ustaloną sumę ubezpieczenia. ',
            'Poważne zachorowanie może mieć bardzo negatywne następstwa również dla finansów rodziny. Niezależnie od tego czy choroba spowoduje spadek lub utratę dochodów czy konieczność poniesienia czasami ogromnych wydatków na nierefundowane świadczenia medyczne warto dysponować budżetem ubezpieczeniowym, który weźmie na siebie to finansowe uderzenie. ',
            'Zaprojektuj dla siebie budżet ubezpieczeniowy tak by odpowiadał zarówno Twoim potrzebom jak i finansowym możliwościom - w trudnej chwili zwiększysz swoje szanse na szybką diagnostykę i wdrożenie optymalnego leczenia. ',
          ],
        },
        budget: {
          tooltip: 'Zabezpiecz środki na wydatki związane z leczeniem ... ',
          title: 'Budżet na nierefundowane świadczenia' + 'medyczne',
          text: [
            'W świetle analiz uznanej fundacji onkologicznej Alivia, do 67% terapii lekowych występujących w standardach europejskich polscy pacjenci nie mają dostępu lub jest on znacznie ograniczony.  ',
            'Budżet ubezpieczeniowy ma więc zapewnić finansowanie nie tylko nowoczesnego leczenia ale również całego katalogu innych nierefundowanych wydatków związanych z np: cykliczną diagnostyką, rehabiltacją, transportem medycznym ... ',
            'Zobacz, jaki odsetek zbiórek, realizowanych w ramach fundacji Alivia dla osób dotknietych chorobą nowotworową, byłby sfinansowany budżetem w ustalonej przez Ciebie wysokości.',
          ],
        },
        monthlySupport: {
          tooltip:
            'Zabezpiecz środki na bieżące funkcjonowanie w związku z obniżeniem dochodów ... ',
          title: 'Miesięczne wsparcie w okresie leczenia',
          text: [
            'Walka z poważnym schorzeniem może oznaczać niezdolność do wykonywania pracy zarobkowej. W zależności od sytuacji rodzinnej, zawodowej i formy zarobkowania może to mieć różne następstwa dla sytuacji finansowej rodziny. ',
            'Pracownik etatowy, w okresie 6 miesięcy, może liczyć na 80% dotychczasowych dochodów, osoba prowadząca działalność gospodarczą i opłacająca składkę chorobową - na zasiłek na poziomie ok. 1.800zł netto. ',
            'Projektując budżet ubezpieczeniowy warto zastanowić się nad finansowaniem codziennego życia rodziny w sytuacji, gdy my prowadzić będziemy walkę o powrót do zdrowia. ',
          ],
        },
        lifeInsurrance: {
          tooltip:
            'Zbuduj solidny fundament swojego planu ubezpieczeniowego ...',
          title: 'Ubezpieczenie na życie',
          text: [
            'W naszym przekonaniu, dobrze zaprojektowane ubezpieczenie na życie powinno być fundamentem wszelkich rodzinnych planów finansowych. Niezależnie od życiowego scenariusza dajemy najbliższym gwarancję jakiejś stabilizacji i pewność dokończenia najważniejszych spraw. ',
            'Poświęć chwilę na analizę i refleksję na temat tego, w jaki sposób zaprojektować swoje ubezpieczenie na życie. ',
          ],
        },
        debt: {
          tooltip: 'Zaplanuj środki na reorganizację finansów rodziny ...',
          title: 'Zadłużenie i inne zobowiązania',
          text: [
            'Reorganizacja finansów rodziny musi wynikać z analizy dochodów i wydatków w nowej sytuacji - może w Waszym przypadku trzeba skoncentrwać się na obniżeniu wydatków (spłata kredytu) a może na utrzymaniu dochodów (restrukturyzacja firmy rodzinnej). ',
            'Planując ubezpieczenie na życie musisz zdecydować, co powinno zostać natychmiast sfinansowane np: ',
            '1. Spłata zadłużenia - aktualne saldo kredytów i pożyczek, zadłużenie u osób prywatnych,   \n' +
              '2. Firma rodzinna - środki na utrzymanie ciągłości firmy albo na jej likwidację, \n' +
              '3. Projekty - środki na dokończenie rozpoczętych przedsięwzięć: budowa domu, fundusz edukacyjny dzieci ...',
          ],
        },
        monthlyFamiliSupport: {
          tooltip:
            'Zaplanuj środki na co miesięczne uzupełnienie budżetu domowego ...',
          title: 'Misięczne wsparcie dla rodziny',
          text: [
            'Jeśli jesteś głównym albo jedynym żywicielem rodziny może się okazać, że niezbędne będzie zaplanowanie długookresowego, comiesięcznego uzupełnienia budżetu domowego. Zastanów się jaka kwota powoli im żyć na poziomie, jaki chciałbyś/chciałabyś im zapewnić. ',
            'Jeśli jesteś objęty ubezpieczeniem społecznym i masz dzieci, możliwe, że przysługiwać im będzie renta rodzinna. Poczytaj na stronach ZUS o tym świadczeniu - w kalkulatorze dostępnym w aplikacji przybliżysz sobie jego wysokość. Możesz wziąć to pod uwagę planując wsparcie dla rodziny.',
          ],
        },
        period: {
          tooltip: 'Zaplanuj okres zabezpieczenia swoich bliskich ...',
          title: 'Okres zabezpieczenia bliskich',
          text: [
            'Wskazanie okresu powoduje odpowiednie przeliczenie rekomendowanej sumy ubezpieczenia na wypadek śmierci - pomnożymy ustaloną wysokość miesięcznego wsparcia przez liczbę miesięcy w podanym okresie. Zastanówcie się wspólnie nad wyborem któregoś z modeli - ustalony okres np. 5,10 lat albo ustalona data np. pełnoletniość najmłodszego dziecka. Pamiętaj o tym, że składka ubezpieczeniowa musi być adekwatna do Twoich aktualnych możliwości finansowych oraz o tym, że dzisiejsze deklaracje dotyczące poziomu ochrony ubezpieczeniowej nie są wiążące na lata - będziesz mógł/mogła w przyszłości ją dostosowywać do zmieniających się okoliczności. ',
          ],
        },
        guarantee: {
          tooltip:
            'Ustaw gwarancję stałej składki za ubezpieczenie na życie ...',
          title: 'Gwarancja stałej składki w okresie zabezpieczenia',
          text: [
            'Możesz wybrać jeden z dwóch typów ochrony ubezpieczeniowej - umowa roczna albo umowa terminowa. ',
            'W wariancie rocznym, umowa zawierana jest na 1 rok i automatycznie przedłużana na kolejne roczne okresy. Składka ubezpieczeniowa ustalana jest zgodnie z taryfą dla osoby w danym wieku co oznacza, że w każdym kolejnym roku składka zostaje podniesiona - w okresie od 35r.życia do 60r.życia składka będzie corocznie wzrastać średnio o 7,2%. ',
            'Wariant terminowy jest umową na określoną liczbę lat (min. 5lat) i w okresie umownym składka pozostaje na niezmienionym poziomie. Porównując oba typy pod kątem sumy opłaconych składek, przy takim samym okresie i sumie ubezpieczenia, w wariancie terminowym zapłacimy mniej o ok.5%',
          ],
        },
      },
    }
  },
  methods: {
    showInfoModal(data) {
      this.$refs.modalInfo.open(data)
    },
    showCalc() {
      this.$refs.optionalCalc.open()
    },
    setCachedValues() {
      // eslint-disable-next-line no-unused-vars
      const cache = JSON.parse(localStorage.getItem('calculation'))
      this.age = cache.age
      if (cache.lifeInsurance.isActive) {
        this.isLifeInsuranceActive = true
        this.lifeInsurance.period = cache.lifeInsurance.period
        this.lifeInsurance.debt = cache.lifeInsurance.debt
        this.lifeInsurance.familySupport = cache.lifeInsurance.familySupport
        this.lifeInsurance.guarantee = cache.lifeInsurance.guarantee
      } else {
        this.isLifeInsuranceActive = false
        this.lifeInsurance.period = 10
      }
      if (cache.moneySupport.isActive) {
        this.isMoneySupportActive = true
        this.moneySupport.monthlySupport = cache.moneySupport.monthlySupport
        this.moneySupport.budget = cache.moneySupport.budget
      } else {
        this.isMoneySupportActive = false
      }
      if (cache.treatmentAbroad.isActive) {
        this.isTreatmentAbroadActive = true
        this.treatmentAbroad.personal = cache.treatmentAbroad.personal
        this.treatmentAbroad.family = cache.treatmentAbroad.family
      } else {
        this.isTreatmentAbroadActive = false
      }
    },
    setDefaultValues() {
      this.isLifeInsuranceActive = false
      this.lifeInsurance.period = 10
      this.lifeInsurance.debt = 200000
      this.lifeInsurance.familySupport = 1500
      this.lifeInsurance.guarantee = false
      this.isMoneySupportActive = false
      this.moneySupport.monthlySupport = 1500
      this.moneySupport.budget = 100000
      this.isTreatmentAbroadActive = false
      this.treatmentAbroad.personal = true
      this.treatmentAbroad.family.active = false
      this.treatmentAbroad.family.adults = 2
      this.treatmentAbroad.family.children = 2
    },
    nextStep() {
      localStorage.setItem(
        'calculation',
        JSON.stringify({
          age: this.age,
          planType: this.planType,
          maxContractTerm: this.maxContractTerm,
          lifeInsToMinVal: this.lifeInsToMinVal,
          additionalSumIllness:
            !this.additionalSumIllness || this.additionalSumIllness !== Infinity
              ? this.additionalSumIllness
              : 0,
          additionalSumInsurance:
            !this.additionalSumInsurance ||
            this.additionalSumInsurance !== Infinity
              ? this.additionalSumInsurance
              : 0,
          illnessToMinVal: this.illnessToMinVal,
          lifeInsurance: this.isLifeInsuranceActive
            ? {
                isActive: true,
                period: parseInt(this.lifeInsurance.period),
                debt: parseInt(this.lifeInsurance.debt),
                familySupport: parseInt(this.lifeInsurance.familySupport),
                guarantee: this.lifeInsurance.guarantee,
                lifeInsuranceSum: this.lifeInsuranceSum,
                monthlyContribution: parseFloat(this.lifePar3),
              }
            : {
                isActive: false,
              },
          moneySupport: this.isMoneySupportActive
            ? {
                isActive: true,
                monthlySupport: parseInt(this.moneySupport.monthlySupport),
                budget: parseInt(this.moneySupport.budget),
                moneySupportSum: this.moneySupportSum,
                monthlyContribution: parseFloat(this.illnessPar3),
              }
            : {
                isActive: false,
              },
          treatmentAbroad: this.isTreatmentAbroadActive
            ? {
                isActive: true,
                personal: this.treatmentAbroad.personal,
                family: {
                  active: this.treatmentAbroad.family.active,
                  children: parseInt(this.treatmentAbroad.family.children),
                  adults: parseInt(this.treatmentAbroad.family.adults),
                },
                monthlyContribution: parseFloat(this.treatmentAbroadPar1),
              }
            : {
                isActive: false,
              },
          finalMonthlySum: parseFloat(this.finalMonthlySum),
        })
      )
      this.$router.push('/summary' + this.$store.state.query)
    },
    setTooltips() {
      this.chartOptions.tooltips.enabled = this.finalMonthlySum > 0
    },
    setChartData() {
      if (
        this.isTreatmentAbroadActive ||
        this.isMoneySupportActive ||
        this.isLifeInsuranceActive
      ) {
        this.chartData = {
          labels: [
            ' Ubezpieczenie na życie',
            ' Finansowanie leczenia za granicą',
            ' Wsparcie finansowe w chorobie',
          ],
          datasets: [
            {
              data: [
                this.lifePar3.toFixed(2),
                this.treatmentAbroadPar1.toFixed(2),
                this.illnessPar3.toFixed(2),
              ],
              backgroundColor: ['#9C27B0', '#F44336', '#FF9800'],
            },
          ],
        }
      } else {
        this.chartData = {
          labels: [' '],
          datasets: [
            {
              data: [1],
              backgroundColor: ['#eee'],
            },
          ],
        }
      }
    },
    async setup() {
      await this.$store.dispatch('getAllConstants', { age: this.age })
      await this.getConstants()
      await this.setChartData()
      try {
        await this.setCachedValues()
      } catch (e) {
        await this.setDefaultValues()
      }
      this.loading = false
    },
    async getConstants() {
      await Axios.post(
        `${process.env.VUE_APP_API_URL}/Constants/api/Constants/GetAllValue`,
        { option: 'all' }
      ).then(res => {
        this.Min_skladka_PO = parseInt(res.data.Min_skladka_PO.value)
        this.Oplata_admin = parseInt(res.data.Oplata_admin.value)
        this.Min_SU = parseInt(res.data.Min_SU.value)
        this.Max_SU = parseInt(res.data.Max_SU.value)
        this.Max_wiek_umowa = parseInt(res.data.Max_wiek_umowa.value)
        this.Min_wiek_umowa = parseInt(res.data.Min_wiek_umowa.value)
        this.Min_okres_term = parseInt(res.data.Min_okres_term.value)
        this.Okres_ochrony = parseInt(res.data.Okres_ochrony.value)
        this.Min_SU_PZ = parseInt(res.data.Min_SU_PZ.value)
        this.Max_SU_PZ = parseInt(res.data.Max_SU_PZ.value)
        this.Skladka_roczna_DOM = parseInt(res.data.Skladka_roczna_DOM.value)
        this.Skladka_mies_DOM = parseInt(res.data.Skladka_mies_DOM.value)
        this.Min_renta_rodz = parseInt(res.data.Min_renta_rodz.value)
        this.Min_renta_rodz_nie = parseInt(res.data.Min_renta_rodz_nie.value)
        this.Kwota_renta_rodz = parseInt(res.data.Kwota_renta_rodz.value)
        this.Wiek_emeryt = parseInt(res.data.Wiek_emeryt.value)
        this.Wskaznik_renta_rodz = parseInt(res.data.Wskaznik_renta_rodz.value)
        this.Stopa_renta_rodz = parseInt(res.data.Stopa_renta_rodz.value)
        this.Skladka_17 = parseInt(res.data.Skladka_17.value)
        this.Skladka_64 = parseInt(res.data.Skladka_64.value)
        this.Staz_renta_rodz = parseInt(res.data.Staz_renta_rodz.value)
        this.Max_renta_rodz_wymiary = parseInt(
          res.data.Max_renta_rodz_wymiary.value
        )
        this.maxContractTerm = parseInt(res.data.Max_wiek_term.value) - this.age
        this.maxAnnualContractTerm = parseInt(res.data.Max_wiek_rocz.value)
        this.isIllnessInsuranceAvailable =
          this.age >= parseInt(res.data.Min_wiek_umowa_PZ.value) &&
          this.age <= parseInt(res.data.Max_wiek_umowa_PZ.value)
        this.isTreatmentAbroadAvailable =
          this.age <= parseInt(res.data.Max_wiek_LzG.value)
      })
    },
  },
  watch: {
    enterPar1(newValue, oldValue) {
      if (oldValue !== newValue) {
        this.setChartData()
      }
    },
    illnessPar3(newValue, oldValue) {
      if (oldValue !== newValue) {
        this.setChartData()
      }
    },
    treatmentAbroadPar1(newValue, oldValue) {
      if (oldValue !== newValue) {
        this.setChartData()
      }
    },
    finalMonthlySum(newValue, oldValue) {
      if (oldValue !== newValue) {
        this.setTooltips()
      }
    },
  },
  computed: {
    ...mapState({
      budgetPercentageArray: state => state.constants.percentageArray,
      monthlyFeeIllness: state => state.constants.monthlyFeeIllness,
      medConsult: state => state.constants.medConsult,
      monthlyFee: state => state.constants.monthlyFee,
    }),
    budgetPercentage() {
      return this.moneySupport.budget == 0
        ? 0 + '%'
        : this.budgetPercentageArray[this.moneySupport.budget / 5000 - 1] + '%'
    },
    //wskaźnik składki term
    lifePar1() {
      return this.insuranceTerm < 5
        ? this.monthlyFee[0]
        : this.monthlyFee[this.insuranceTerm - 4]
      //34.47 API
    },
    //wskaźnik składki roczny
    lifePar2() {
      return this.isLifeInsuranceActive ? this.monthlyFee[0] : 0
    },
    lifePar4() {
      return this.planType
        ? (this.lifeInsuranceSum * this.lifePar1) / 100000 + this.Oplata_admin
        : (this.lifeInsuranceSum * this.lifePar2) / 100000 + this.Oplata_admin
    },
    //wstępna składka życie
    lifePar3() {
      return this.isLifeInsuranceActive
        ? !this.isMoneySupportActive && this.lifePar4 < this.Min_skladka_PO
          ? this.Min_skladka_PO
          : this.lifePar4
        : 0
    },
    lifeInsToMinVal() {
      return (
        this.isLifeInsuranceActive &&
        !this.isMoneySupportActive &&
        this.lifePar4 < this.Min_skladka_PO
      )
    },
    additionalSumInsurance() {
      return this.lifeInsToMinVal
        ? this.planType
          ? Math.round(
              ((this.Min_skladka_PO - this.lifePar4) * 100000) / this.lifePar1
            )
          : Math.round(
              ((this.Min_skladka_PO - this.lifePar4) * 100000) / this.lifePar2
            )
        : 0
    },
    //wstępna składka leczenia za granicą
    treatmentAbroadPar1() {
      return this.isTreatmentAbroadAvailable &&
        this.isTreatmentAbroadActive &&
        this.treatmentAbroad.personal
        ? this.Skladka_64
        : this.isTreatmentAbroadAvailable &&
          this.treatmentAbroad.family.active &&
          this.isTreatmentAbroadActive
        ? this.treatmentAbroad.family.children * this.Skladka_17 +
          this.treatmentAbroad.family.adults * this.Skladka_64
        : 0
    },
    //wskaźnik składki PZ
    illnessPar1() {
      return this.isMoneySupportActive ? this.monthlyFeeIllness : 0
    },
    //wstępna składka PZ
    illnessPar2() {
      return parseFloat(
        this.isMoneySupportActive && !this.isLifeInsuranceActive
          ? (
              (this.moneySupportSum * this.illnessPar1) / 100000 +
              this.Oplata_admin +
              this.medConsult
            ).toFixed(2)
          : this.isMoneySupportActive && this.isLifeInsuranceActive
          ? (
              (this.moneySupportSum * this.illnessPar1) / 100000 +
              this.medConsult
            ).toFixed(2)
          : 0
      )
    },
    illnessPar3() {
      return this.isMoneySupportActive
        ? !this.isLifeInsuranceActive && this.illnessPar2 < this.Min_skladka_PO
          ? this.Min_skladka_PO
          : this.isLifeInsuranceActive &&
            this.lifePar3 + this.illnessPar2 < this.Min_skladka_PO
          ? this.Min_skladka_PO - this.lifePar3
          : this.illnessPar2
        : 0
    },
    additionalSumIllness() {
      return Math.round(
        ((this.Min_skladka_PO - this.illnessPar2) * 100000) / this.illnessPar1
      )
    },

    illnessToMinVal() {
      return (
        (this.isMoneySupportActive &&
          !this.isLifeInsuranceActive &&
          this.illnessPar2 < this.Min_skladka_PO) ||
        (this.isLifeInsuranceActive &&
          this.lifePar3 + this.illnessPar2 < this.Min_skladka_PO)
      )
    },
    planType() {
      return parseInt(this.lifeInsurance.period) < this.Min_okres_term
        ? false
        : this.lifeInsurance.guarantee
    },
    insuranceTerm() {
      return parseInt(
        this.planType && this.lifeInsurance.period > this.maxContractTerm
          ? this.maxContractTerm
          : !this.planType &&
            this.lifeInsurance.period > this.maxAnnualContractTerm
          ? this.maxAnnualContractTerm
          : this.lifeInsurance.period
      )
    },
    //wstępna składka PO
    enterPar1() {
      return this.isLifeInsuranceActive || this.isMoneySupportActive
        ? this.lifePar3 + parseFloat(this.illnessPar3)
        : 0
    },
    // składka za plan ubezp
    finalMonthlySum() {
      return this.isLifeInsuranceActive ||
        this.isMoneySupportActive ||
        this.isTreatmentAbroadActive
        ? this.enterPar1 + this.treatmentAbroadPar1
        : 0
    },
    lifeInsuranceSum() {
      let sliderVar =
        parseInt(this.lifeInsurance.debt) +
        parseInt(this.lifeInsurance.period) *
          12 *
          parseInt(this.lifeInsurance.familySupport)
      return Math.max(Math.min(sliderVar, this.Max_SU), this.Min_SU)
    },
    moneySupportSum() {
      return Math.max(
        Math.min(
          parseInt(this.moneySupport.monthlySupport) * this.Okres_ochrony +
            parseInt(this.moneySupport.budget),
          10000000
        ),
        1000
      )
    },
  },
}
</script>

<style scoped lang="scss">
h4.title {
  font-size: 21px;
  font-weight: 500;
  @media screen and (max-width: 768px) {
    font-size: 20px;
  }
  @media screen and (max-width: 576px) {
    font-size: 16px;
  }
}
.wrapp {
  position: relative;
  width: 100%;
  max-width: 825px;
  margin-top: 120px;
  @media screen and (max-width: 1200px) {
    max-width: 680px;
  }
  @media screen and (max-width: 991px) {
    max-width: 100%;
  }
  @media screen and (max-width: 768px) {
    padding-bottom: 40px;
  }
  @media screen and (max-width: 576px) {
    margin-top: 70px;
  }
}
.config-block {
  padding: 0 50px 33px;
  border-bottom: 2px solid #eee;
  &:last-child {
    border-bottom: 0;
    padding-bottom: 0;
  }
  @media screen and (max-width: 1200px) {
    padding: 0 15px;
  }
  @media screen and (max-width: 768px) {
    padding: 0;
  }
  &__header {
    margin-top: 33px;
    display: flex;
    align-items: center;
    @media screen and (max-width: 576px) {
      margin-top: 0;
    }
  }
  &__switch {
    margin-left: 10px;
  }
}

.info-icon {
  margin-left: 10px;
}
.slider-block {
  max-width: 690px;
  margin: 20px auto 0;
  @media screen and (max-width: 576px) {
    /*margin-top: 10px;*/
  }
  &:first-child {
    margin-top: 50px;
    @media screen and (max-width: 576px) {
      margin-top: 10px;
    }
  }
  &__info {
    font-size: 20px;
    @media screen and (max-width: 768px) {
      font-size: 17px;
    }
  }
  &__label {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  &__name {
    font-size: 15px;
  }
  &__display-value {
    text-align: right;
    font-weight: 500;
    font-size: 18px;
    color: #3c4858;
    @media screen and (max-width: 576px) {
      font-size: 15px;
    }
  }
  &__sum {
    margin-top: 40px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    span {
      font-weight: 700;
      color: #3c4858;
      @media screen and (max-width: 576px) {
        font-size: 16px;
      }
    }
    @media screen and (max-width: 576px) {
      margin-top: 0;
    }
  }
  &__value {
    font-size: 25px;
    @media screen and (max-width: 768px) {
      font-size: 20px;
    }
    @media screen and (max-width: 576px) {
      font-size: 18px;
    }
  }
}
.labeled-toggler {
  display: flex;
  max-width: 220px;
  align-items: center;
  padding-left: 17px;
  justify-content: space-between;
  margin: 20px auto 0;
  &_wide {
    max-width: 720px;
    font-size: 16px;
    padding-left: 0;
    .labeled-toggler__actions-block {
      display: flex;
      align-items: center;
      .config-block__switch {
        margin-right: 0;
      }
    }
    @media screen and (max-width: 576px) {
      padding: 0;
    }
  }
}
.select {
  max-width: 140px;
  @media screen and (max-width: 576px) {
    max-width: 100%;
  }
  &_family {
    margin-top: 30px;
  }
}
.chart-wrapp {
  position: relative;
  margin-top: 30px;
  @media screen and (max-width: 1200px) {
    margin-top: 15px;
  }
  @media screen and (max-height: 710px) {
    margin-top: 15px;
  }
}
.chart-card {
  position: fixed;
  top: 120px;
  max-width: 285px;
  width: 100%;
  right: calc(50% - 571px);
  @media screen and (max-width: 1200px) {
    max-width: 255px;
    right: calc(50% - 481px);
  }
  @media screen and (max-width: 991px) {
    display: none;
  }
  .md-card-content {
    @media screen and (max-width: 1200px) {
      padding-bottom: 10px;
    }
    @media screen and (max-height: 710px) {
      padding: 10px 15px;
    }
  }
  button {
    @media screen and (max-width: 1200px) {
      font-size: 11px;
    }
  }
  &-nav {
    margin-top: 5px;
    text-align: right;
    &__link {
      padding: 10px;
      border-radius: 4px;
      &:hover {
        background-color: rgba(245, 132, 31, 0.21);
        cursor: pointer;
      }
      i {
        font-size: 34px !important;
        color: #f5841f !important;
        display: inline-flex;
      }
    }
  }
}
.final-part-info {
  color: #707070;
  width: 250px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  z-index: -1;
  height: 110px;
  position: absolute;
  margin-left: -125px;
  margin-top: -55px;
  top: 50%;
  left: 50%;
  text-align: center;
  &__sum {
    font-size: 25px;
    font-weight: 500;
    margin-top: 15px;
  }
  p {
    font-size: 14px;
    margin: 0;
  }
  p:first-child {
    font-weight: 500;
  }
  p:last-child {
    font-weight: 300;
  }
}
.chart-legend {
  @media screen and (max-height: 710px) {
    margin-top: 10px;
  }
  &__item {
    display: flex;
    align-items: center;
    margin-top: 10px;
    @media screen and (max-width: 1200px) {
      margin-top: 0;
    }
    @media screen and (max-height: 710px) {
      margin-top: 0;
    }
  }
  &__indicator {
    height: 12px;
    width: 12px;
    border-radius: 50%;
    @media screen and (max-width: 1200px) {
      height: 10px;
      width: 10px;
    }
  }
  &__name {
    font-size: 12px;
    color: #3c4858;
    margin-left: 6px;
    @media screen and (max-width: 1200px) {
      font-size: 11px;
    }
  }
}
.chart-btn {
  width: 100%;
  margin-top: 31px;
  font-size: 12px;
  @media screen and (max-width: 1200px) {
    margin-top: 10px;
  }
  @media screen and (max-height: 710px) {
    margin-top: 10px;
  }
  .md-ripple {
    padding: 0;
  }
}
.bottom-nav {
  position: fixed;
  bottom: 0;
  left: 0;
  display: none;
  align-items: center;
  padding: 10px 20px 10px 10px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.14);
  justify-content: space-between;
  z-index: 10;
  width: 100%;
  background-color: #fff;
  @media screen and (max-width: 991px) {
    display: flex;
  }
  &__text {
    font-size: 21px;
    @media screen and (max-width: 576px) {
      font-size: 17px;
    }
  }
  &__sum {
    font-weight: 700;
  }
}
</style>
